const level = "admin";
const ALL = ["admin", "manager", "caixa"];
const POS_ACCESS = [...ALL, "farmacia", "clinica"];
const TECHNICAL = ["manager"];
const ESTABLISHMENT_MANAGEMENT = ["admin", "manager"];
const CAIXA_PATHS = new Set(["/app/facturacao/atos"]);

const menu = [
  {
    path: "/",
    title: "Painel de controle",
    icon: "bx bx-home-circle",
    level,
  },
  {
    title: "Facturação e POS",
    icon: "bx bx-receipt",
    level,
    children: [
      {
        title: "Gestão de Estoque",
        icon: "bx bx-package",
        children: [
          {
            path: "/app/estoque/produtos",
            icon: "bx bx-box",
            title: "Produtos",
            level,
          },
          {
            path: "/app/estoque/servicos",
            icon: "bx bx-briefcase",
            title: "Serviços",
            level,
          },
          {
            path: "/app/estoque/especialidades",
            icon: "bx bx-plus-medical",
            title: "Especialidades",
            level,
          },
          {
            path: "/app/estoque/ajuste",
            icon: "bx bx-slider",
            title: "Ajuste de Estoque",
            level: ESTABLISHMENT_MANAGEMENT,
          },
          {
            path: "/app/estoque/inventario",
            icon: "bx bx-clipboard",
            title: "Inventário",
            level: ESTABLISHMENT_MANAGEMENT,
          },
        ],
      },
      {
        title: "Operações",
        icon: "bx bx-task",
        children: [
          {
            path: "/app/facturacao/clientes",
            icon: "bx bx-user",
            title: "Gerir Clientes",
            level,
          },
          {
            path: "/app/facturacao/documento",
            icon: "bx bx-money",
            title: "Emitir Documento",
            level,
          },
          {
            path: "/app/facturacao/pos",
            icon: "bx bx-money",
            title: "Ponto de Venda",
            level,
          },
          {
            path: "/app/facturacao/documentos-emitidos",
            icon: "bx bx-block",
            title: "Documentos emitidos",
            level,
          },
          {
            path: "/app/facturacao/anular-factura",
            icon: "bx bx-undo",
            title: "Anular factura",
            level,
          },
          {
            path: "/app/facturacao/listar-facturas",
            icon: "bx bx-cloud-download",
            title: "Sincronizar Facturas",
            level,
          },
          {
            path: "/app/facturacao/consultar-factura",
            icon: "bx bx-file",
            title: "Consultar Factura",
            level,
          },
          {
            path: "/app/tesouraria/secretaria/despesas",
            icon: "bx bx-wallet-alt",
            title: "Despesas",
            level,
          },
        ],
      },
      {
        title: "Seguradoras",
        icon: "bx bx-health",
        children: [
          {
            path: "/app/facturacao/seguradoras",
            icon: "bx bx-shield-quarter",
            title: "Gerir Seguradoras",
            level,
          },
          {
            path: "/app/facturacao/pessoas-cobertas",
            icon: "bx bx-user",
            title: "Pessoas cobertas",
            level,
          },
          {
            path: "/app/facturacao/catalogo-atos",
            icon: "bx bx-plus-medical",
            title: "Actos clínicos",
            level,
          },
          {
            path: "/app/facturacao/atos",
            icon: "bx bx-receipt",
            title: "Factura de actos clínicos",
            level,
          },
          {
            path: "/app/facturacao/relatorio-seguradoras",
            icon: "bx bx-bar-chart-alt-2",
            title: "Relatório de facturas",
            level,
          },
        ],
      },
      {
        title: "Relatórios",
        icon: "bx bx-file",
        children: [
          {
            path: "/app/relatorios/fluxo-caixa",
            icon: "bx bx-transfer",
            title: "Fluxo de Caixa",
            level,
          },
          {
            path: "/app/relatorios/devedores",
            icon: "bx bx-user-x",
            title: "Lista de Devedores",
            level,
          },
          {
            path: "/app/relatorios/conta-corrente",
            icon: "bx bx-book-open",
            title: "Conta Corrente",
            level,
          },
          {
            path: "/app/relatorios/fecho-diario",
            icon: "bx bx-calendar-check",
            title: "Fecho Diário",
            level,
          },
        ],
      },
    ],
  },
  {
    title: "Gerir Website",
    icon: "bx bx-globe",
    children: [
      {
        title: "Informação",
        icon: "bx bx-info-circle",
        children: [
          {
            path: "/app/website/noticias",
            icon: "bx bx-news",
            title: "Notícias",
            level,
          },
          {
            path: "/app/website/eventos",
            icon: "bx bx-calendar-event",
            title: "Eventos",
            level,
          },
          {
            path: "/app/website/slideshow",
            icon: "bx bx-slideshow",
            title: "Slideshow",
            level,
          },
          {
            path: "/app/website/equipe",
            icon: "bx bx-group",
            title: "Equipe",
            level,
          },
          {
            path: "/app/website/galeria",
            icon: "bx bx-images",
            title: "Galeria",
            level,
          },
          {
            path: "/app/website/parceiros",
            icon: "bx bx-group",
            title: "Parceiros",
            level,
          },
          {
            path: "/app/website/agendamentos",
            icon: "bx bx-calendar-check",
            title: "Agendamentos",
            level,
          },
        ],
      },
    ],
  },
  {
    title: "Estatísticas",
    icon: "bx bx-pie-chart-alt-2",
    level,
    children: [
      {
        path: "/app/estatisticas/geral",
        icon: "bx bx-bar-chart",
        title: "Geral",
        level: TECHNICAL,
      },
      {
        path: "/app/estatisticas/produtos",
        icon: "bx bx-bar-chart",
        title: "Produtos",
        level: ESTABLISHMENT_MANAGEMENT,
      },
      {
        path: "/app/estatisticas/clientes",
        icon: "bx bx-user-check",
        title: "Clientes",
        level,
      },
      {
        path: "/app/estatisticas/documentos",
        icon: "bx bx-file-blank",
        title: "Documentos",
        level,
      },
      {
        path: "/app/estatisticas/dashboard-fe",
        icon: "bx bx-tachometer",
        title: "Dashboard FE",
        level,
      },
      {
        path: "/app/estatisticas/financeiro",
        icon: "bx bx-line-chart",
        title: "Financeiro",
        level,
      },
    ],
  },
  {
    title: "Configurações",
    icon: "bx bx-cog",
    level,
    children: [
      {
        path: "/config/series",
        icon: "bx bx-list-ol",
        title: "Séries",
        level: TECHNICAL,
      },
      {
        path: "/config/bancos",
        icon: "bx bx-building-house",
        title: "Bancos",
        level,
      },
      {
        path: "/config/categorias",
        icon: "bx bx-category",
        title: "Categorias",
        level,
      },
      {
        path: "/config/armazens",
        icon: "bx bx-store",
        title: "Armazéns",
        level,
      },
      {
        path: "/auth/notificacoes",
        icon: "bx bx-bell",
        title: "Minhas notificações",
        level,
      },
      {
        path: "/empresa/perfil",
        icon: "bx bx-building",
        title: "Perfil da empresa",
        level: TECHNICAL,
      },
      {
        path: "/app/ferramentas/velocidade",
        icon: "bx bx-tachometer",
        title: "Velocidade da internet",
        level,
      },
      {
        path: "/empresa/estabelecimentos",
        icon: "bx bx-buildings",
        title: "Estabelecimentos",
        level: TECHNICAL,
      },
    ],
  },
  {
    title: "Autenticação",
    icon: "bx bx-shield-quarter",
    level,
    children: [
      {
        path: "/auth/actividades",
        icon: "bx bx-history",
        title: "Registo de actividade",
        level,
      },
      {
        path: "/auth/users",
        icon: "bx bx-user-pin",
        title: "Utilizadores",
        level,
      },
    ],
  },
];

const permissionsFor = (path) => {
  if (!path) return ALL;
  if (path === "/" || path === "/painel-controle") return ["admin", "manager"];
  if (path === "/empresa/estabelecimentos" || path === "/config/series")
    return ["manager"];
  if (path === "/app/facturacao/pos") return POS_ACCESS;
  if (CAIXA_PATHS.has(path)) return ALL;
  if (path === "/perfil") return ESTABLISHMENT_MANAGEMENT;
  if (["/auth/users", "/auth/actividades"].includes(path))
    return ESTABLISHMENT_MANAGEMENT;
  if (["/empresa/perfil", "/empresa/licenciamento"].includes(path))
    return TECHNICAL;
  if (path.startsWith("/auth/") || path.startsWith("/empresa/"))
    return TECHNICAL;
  return ["admin", "manager"];
};

const applyPermissions = (items) =>
  items.map((item) => {
    const children = item.children
      ? applyPermissions(item.children)
      : undefined;
    const levels = item.path
      ? permissionsFor(item.path)
      : [...new Set((children || []).flatMap((child) => child.level || []))];
    return {
      ...item,
      ...(children ? { children } : {}),
      level: levels.length ? levels : ALL,
    };
  });

const securedMenu = applyPermissions(menu);

export const hasMenuAccess = (path, role) =>
  permissionsFor(path).includes(role);

export const firstAccessiblePath = (role) => {
  const flatten = (items) =>
    items.flatMap((item) => (item.children ? flatten(item.children) : [item]));
  return (
    flatten(securedMenu).find((item) => item.path && item.level.includes(role))
      ?.path || "/auth/login"
  );
};

export default securedMenu;
